import { render, staticRenderFns } from "./PosContactUnit.vue?vue&type=template&id=e0448496&"
import script from "./PosContactUnit.vue?vue&type=script&lang=js&"
export * from "./PosContactUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports